import { Component } from '@angular/core';
import { PolicyHeaderComponent } from '../policy-pages/policy-header/policy-header.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-about-us',
    imports: [PolicyHeaderComponent, CommonModule],
    templateUrl: './about-us.component.html',
    styleUrl: '../policy-pages/policy-page.css'
})
export class AboutUsComponent {
  isLogin = false;
  ngOnInit() {
    this.isLogin = localStorage.getItem('isLogedIn') === 'true';
  }
}
